import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { CountryTree, ICountryTreeProps } from './CountryTree';

const GetCountryListQuery = gql`
  query {
    countries {
      id
      name
      title
      code
      parentCountryId
    }
  }
`;

export default withRouter(compose<{}, ICountryTreeProps>(
  graphql<ICountryTreeProps, any>(GetCountryListQuery, {
    name: 'countries',
  }),
  withProps(({ countries }: any) => {
    return {
      countries: countries.countries,
    };
  }),
)(CountryTree));



// WEBPACK FOOTER //
// ./src/components/Others/CountryTree/index.ts